import { isFeatureActive } from './featureFlags';

type Feature = 'comingSoonPage' | 'zipDownload';
export class Configuration {
  public static readonly ApiUrl = Configuration.trimEnd(import.meta.env.VITE_API_HOST_NAME ?? '', '/') ?? '';
  public static readonly StaticSiteUrl = Configuration.trimEnd(import.meta.env.VITE_STATIC_SITE_URL ?? '', '/') ?? '';

  public static readonly OidcAuthority = Configuration.trimEnd(import.meta.env.VITE_OIDC_AUTHORITY ?? '', '/') ?? '';
  public static readonly OidcClientId = import.meta.env.VITE_OIDC_CLIENT_ID ?? '';
  private static trimEnd(input: string | undefined, chars: string): string | undefined {
    if (input !== null && input !== undefined) {
      while (input.endsWith(chars)) {
        input = input.substring(0, input.length - chars.length);
      }
    }
    return input;
  }

  public static isFeatureEnabled(feature: Feature): boolean {
    const result = isFeatureActive(feature);
    return result === undefined ? false : result;
  }
}
